import tailwindTheme from "../../../tailwind.theme.config.js";

// Adds Tailwind variables to the global scope so they can be used in JavaScript
window.tailwindConfig = tailwindTheme;

window.tailwindConfig.get = function (key) {
	return window.tailwindConfig.extend[key];
};

window.tailwindConfig.themeColors = function (key) {
	return window.tailwindConfig.extend.colors[key];
};
